import { defineMessages } from 'react-intl';

export default defineMessages({
  allVideos: {
    id: 'widget.categories.all-videos',
    defaultMessage: 'All Categories',
  },
});



// WEBPACK FOOTER //
// ./src/widget/components/categories/translations.js